import { render, staticRenderFns } from "./TripTab.vue?vue&type=template&id=7672fb3a&scoped=true&"
import script from "./TripTab.vue?vue&type=script&lang=js&"
export * from "./TripTab.vue?vue&type=script&lang=js&"
import style0 from "./TripTab.vue?vue&type=style&index=0&id=7672fb3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7672fb3a",
  null
  
)

export default component.exports